module.exports = __webpack_public_path__ + "img/Olav_og_Kari_Loft_i_Setesdal.a4a9e1f1.jpg";